import WebApp from '@twa-dev/sdk'
import { createEffect } from 'effector'
import { onError } from '@/app/routing/events'
import { authReq, getFriendsReward, getFriendStatus, getReferralHistory, getUsersByGamedId } from './api'
import { getUserProfile, refreshToken } from './api'

import { deleteRemoveFriend, getUserInfo, postAddFriend, getAllFriendsList, insertUserSettings } from './api'
import { FriendsListResponse, UpdateUserSettingsParamsType, UsersByGamedIdDTO } from '@/entities/user'
import { AuthParamsType } from '@/entities/user'
import { getSteamAuthUrl } from '../platforms/steam/api'
import { PaginationParams } from '@/shared/constants/types'

const authUserFx = createEffect(async (params?: AuthParamsType) => {
  const initData = params?.init_data ?? WebApp.initData
  const data = await authReq({ init_data: initData, ...params })
  return data
})
authUserFx.failData.watch(() => {
  onError()
})

const refreshTokenFx = createEffect(async (token: string) => {
  const data = await refreshToken(token)
  return data
})
refreshTokenFx.failData.watch(() => {
  onError()
})

export const getSteamAuthUrlFx = createEffect(async (userToken: string) => {
  const data = await getSteamAuthUrl(userToken)
  return data
})
getSteamAuthUrlFx.failData.watch(() => {
  onError()
})

// const getSteamProfileFx = createEffect(async (token: string) => {
//   const data = await getUserProfile(token)
//   return data
// })
// getSteamProfileFx.failData.watch(() => {
//   onError()
// })

export const addFriendFx = createEffect(async (params: { token: string; friend_tid: number }) => {
  const data = await postAddFriend(params.token, params.friend_tid)
  return data
})
export const removeFriendFx = createEffect(async (params: { token: string; friend_tid: number }) => {
  const data = await deleteRemoveFriend(params.token, params.friend_tid)
  return data
})

export const getExternalProfileFx = createEffect(async (params: { token: string; tid: number }) => {
  const data = await getUserInfo(params.token, params.tid)
  return data
})
export const getFriendStatusFx = createEffect(
  async (params: { token: string; friend_tid: number }): Promise<boolean> => {
    const data = await getFriendStatus(params.token, params.friend_tid)
    return data
  }
)

export const getFullExternalProfileFx = createEffect(async (params: { token: string; friend_tid: number }) => {
  const [profile, isFriend] = await Promise.all([
    getExternalProfileFx({ token: params.token, tid: params.friend_tid }),
    getFriendStatusFx({ token: params.token, friend_tid: params.friend_tid }),
  ])
  return { ...profile, is_friend: isFriend }
})

type GetFriendsListParams = {
  token: string
  page: number
  size: number
}
export const getFriendsListFx = createEffect(async (params: GetFriendsListParams): Promise<FriendsListResponse> => {
  const { token, page, size } = params
  const data = await getAllFriendsList(token, page, size)
  return data
})

export const insertUserSettingsFx = createEffect(async (params: UpdateUserSettingsParamsType) => {
  const res_data = await insertUserSettings(params)
  return res_data
})

export const getUserProfileFx = createEffect(async (token: string) => {
  try {
    const data = await getUserProfile(token)

    // If settings is undefined or null, replace with empty object
    if (data.settings === undefined || data.settings === null) {
      data.settings = {}
    }
    return data
  } catch (error) {
    onError()
    throw error
  }
})
getUserProfileFx.failData.watch(() => {
  onError()
})

export const ClaimFriendsRewardFx = createEffect(async (token: string) => {
  const data = await getFriendsReward(token)
  return data
})
ClaimFriendsRewardFx.failData.watch(() => {
  onError()
})

export const getReferralHistoryFx = createEffect(async (params: PaginationParams) => {
  const data = await getReferralHistory(params)
  return data
})
getReferralHistoryFx.failData.watch(() => {
  onError()
})
export const getUsersByGamedIdFx = createEffect(async (params: UsersByGamedIdDTO) => {
  const data = await getUsersByGamedId(params)
  return data
})
getUsersByGamedIdFx.failData.watch(() => {
  onError()
})

export { authUserFx, refreshTokenFx }
